module.exports = __webpack_public_path__ + "img/title-3.80b95e18.png";